RivalIQ.apps.Analyze.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    curations.Analyze = curations.Base.mixin({
        loadConfiguration: function () {
            const me = this;
            return RivalIQ.data.chartConfigurations.fetch(me.getProps());
        },

        getExportTitle: function () {
            const me = this;
            return `${me.title()} Detailed Metrics`;
        },

        mixins: {
            ChannelSwitchable: Dashboard.mixins.ChannelSwitchable,
            curationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            RivalIQ.apps.Dashboard.curations.filters.channelWall
        ],

        validCurationOptions: ['channel'],

        processProps: function (props) {
            return _.defaults({
                useUniversalMetricsApi: true
            }, props);
        },

        getPath: function (overrides) {
            const me = this;

            return Dashboard.models.Curation.prototype.getPath.call(me, _.extend({
                channel: me.getProp('channel')
            }, overrides));
        },

        // Disable title dropdown for widget details b/c we cant switch between
        // metrics by just changing the channel :(
        titleView: function () {
            const me = this;
            if (!me.isFocus()) {
                return me.getTitle();
            }
            return me.getSwitchableTitleView();
        },

        getBackPath: function (widgetProps) {
            const me = this;
            const filteredProps = _.pick(widgetProps, me.validCurationOptions);
            return me.getBasePath(filteredProps);
        },

        getBasePath: function (props) {
            const me = this;

            props = _.extend({
                channel: me.getProp('channel')
            }, props);
            return me.router.resolveCurationRoute(me.id, props);
        }
    });

});
